export default __webpack_public_path__ + "static/media/range-usage.cea0292f.svg";